import { ParsedQs } from "qs";

import { Query } from "@/custom-types/Query";

export interface FilterValues {
  selectedCategories: string[] | null;
  selectedFulfillments: string[] | null;
}

export const extractFilterValues = (parsedQs: ParsedQs): FilterValues => {
  const appliedFilters = (parsedQs.filter as Query) || {};

  const selectedCategories = appliedFilters.category
    ? Array.isArray(appliedFilters.category)
      ? (appliedFilters.category as string[])
      : [appliedFilters.category]
    : null;

  const selectedFulfillments = parsedQs.fulfillment
    ? Array.isArray(parsedQs.fulfillment)
      ? (parsedQs.fulfillment as string[])
      : [parsedQs.fulfillment as string]
    : null;

  return {
    selectedCategories,
    selectedFulfillments,
  };
};
